import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Intent } from '@blueprintjs/core';


const ButtonContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const TextContainer = styled.div`
  line-height: 1.4;
  text-align: center;
`;

const IconContainer = styled.div`
  margin-right: 10px;
`;

class BigButton extends React.Component {
  render() {
    const {icon, text, loading, intent, onClick} = this.props;
    return (
      <Button loading={loading} intent={intent} onClick={onClick}>
        <ButtonContent>
          {icon? <IconContainer>{icon}</IconContainer>: null}
          {text? <TextContainer>{text}</TextContainer>: null}
        </ButtonContent>
      </Button>
    )
  }
}

BigButton.propTypes = {
  icon: PropTypes.object,
  text: PropTypes.string,
  loading: PropTypes.bool,
  intent: PropTypes.oneOf([
    Intent.NONE,
    Intent.PRIMARY,
    Intent.SUCCESS,
    Intent.WARNING,
    Intent.DANGER
  ]),
  onClick: PropTypes.func.isRequired
};

BigButton.defaultProps = {
  icon: null,
  text: '',
  loading: false,
  intent: Intent.NONE
};


export default BigButton;



// WEBPACK FOOTER //
// ./src/components/BigButton/index.js